import React from 'react';
import classNames from 'classnames';

import { CloseIcon } from '../icons';

import './alert.scss';

interface Props {
    children?: any;
    onDismiss?: () => void;
    type: string;
}

export default class Alert extends React.Component<Props> {
    public handleClick = (e: any) => {
        e.preventDefault();
        if ( typeof this.props.onDismiss === 'function' ) {
            this.props.onDismiss();
        }
    }

    public render() {
        const { onDismiss, children, type } = this.props;
        const dismissable = !!onDismiss;
        const classes = classNames( {
            'alert-panel': true,
            'dismissable': dismissable,
            'alert-success': type === 'success',
            'alert-error': type === 'error',
            'alert-warning': type === 'warning',
        } );

        return (
            <div role="alert-panel" className={classes} >
                {dismissable &&
                    <a href="#" className="close-btn" onClick={this.handleClick}>
                        <CloseIcon />
                    </a>
                }
                {children}
            </div>
        );
    }
}
